<template>
  <div class="wrapper">
    <div class="animated fadeIn">
      <tabs v-model="activeSubTab" @input="changeSubTab" class="empty-tab">
        <tab
          v-for="(subItem, subIndex) of subTabs"
          :key="`sub-tab-${subIndex}`"
          :header="subItem.label"
        ></tab>
      </tabs>
      <router-view></router-view>
    </div>
  </div>
</template>

<script>
import Tabs from "vue-strap/src/Tabs";
import Tab from "vue-strap/src/Tab";

export default {
  name: "ProspectsContainer",
  components: {
    Tabs,
    Tab,
  },
  data() {
    return {
      activeSubTab: 0,
      subTabs: [
        { label: "Liste", name: "prospects-list" },
        { label: "Carte", name: "prospects-map" },
      ],
    };
  },
  watch: {
    $route(current) {
      this.setCurrentSubTab(current.name);
    },
  },
  created() {
    this.setCurrentSubTab(this.$route.name);
  },
  methods: {
    changeSubTab(index) {
      this.$router.push({ name: this.subTabs[index].name });
    },
    setCurrentSubTab(currentPath) {
      this.activeSubTab = this.subTabs.findIndex(
        (tab) => tab.name === currentPath
      );
    },
  },
};
</script>
